import { Coin, CoinSnapshot, PriceFullRaw } from './../../models/Coin';
import { CoinsProvider } from './../../providers/coins/coins';
import { Component, Input, ChangeDetectorRef } from '@angular/core';
import { InAppBrowser } from '@ionic-native/in-app-browser';

/**
 * Generated class for the CoinSummaryComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'coin-summary',
  templateUrl: 'coin-summary.html'
})

export class CoinSummaryComponent {
  @Input('coin') coin: Coin;
  @Input('coinSnapshot') coinSnapshot: CoinSnapshot;
  imgUrl: string;
  pctChange: number;
  constructor(public CP: CoinsProvider, public cdRef: ChangeDetectorRef, private iab: InAppBrowser ) {
  }

  ngOnInit(){
    this.imgUrl = `https://www.cryptocompare.com/${this.coin.ImageUrl}`;
    this.CP.addCoinsToMap([this.coin]);
  }


  ionViewDidLeave(){
    this.CP.removeCoinsFromMap([this.coin]);
  }

  getPrice(): PriceFullRaw{
    return this.CP.getPrice(this.coin);
  }

  setPctChange(pct: number){
    this.pctChange = pct;
  }

  openLink(url: string){
    this.iab.create(url);
  }

  parseInt(str: string): number{
    if(str) return parseInt(str);
    else return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/coin-summary/coin-summary.ts